import PropTypes from 'prop-types';

export default {
  device: PropTypes.shape({}).isRequired,
  account: PropTypes.shape({}).isRequired,
  dateRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  isAnyMetric: PropTypes.bool.isRequired
};
